import { scrub } from '../../core/scrub/scrub.js';
import { LEVEL_TO_SEVERITY } from '../../core/severity/severity.js';
const CONSOLE_METHOD = {
    trace: 'debug',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
    fatal: 'error',
};
export function createBrowserLogger(options) {
    let correlationId = options.correlationId;
    let sessionId = options.sessionId;
    const redaction = options.redaction ?? true;
    const base = options.defaultFields ?? {};
    function emit(level, message, fields) {
        const entry = {
            severity: LEVEL_TO_SEVERITY[level],
            message,
            timestamp: new Date().toISOString(),
            service: options.service,
            ...(correlationId ? { correlation_id: correlationId } : {}),
            ...(sessionId ? { session_id: sessionId } : {}),
            ...base,
            ...(fields ?? {}),
        };
        const output = redaction ? scrub(entry) : entry;
        const method = CONSOLE_METHOD[level];
        const sink = globalThis.console[method] ?? globalThis.console.log;
        sink(message, output);
    }
    return {
        trace: (message, fields) => emit('trace', message, fields),
        debug: (message, fields) => emit('debug', message, fields),
        info: (message, fields) => emit('info', message, fields),
        warn: (message, fields) => emit('warn', message, fields),
        error: (message, fields) => emit('error', message, fields),
        child: (childFields) => createBrowserLogger({
            ...options,
            correlationId,
            sessionId,
            defaultFields: { ...base, ...childFields },
        }),
        setCorrelationId: (id) => {
            correlationId = id;
        },
        setSessionId: (id) => {
            sessionId = id;
        },
    };
}
//# sourceMappingURL=logger.js.map